import { render, staticRenderFns } from "./DocumentFileUploader.vue?vue&type=template&id=6fc1034c"
import script from "./DocumentFileUploader.vue?vue&type=script&lang=js"
export * from "./DocumentFileUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports